/* ===========================
IMPORTS
=========================== */
import React from 'react';
import { withRouter } from 'react-router-dom';
import ReactDOMClient from 'react-dom/client';
import PropTypes from 'prop-types';
// IMPORT - STYLING
// IMPORT - COMPONENTS
// IMPORT - ELEMENTS
import Tables from '../Elements/Tables';
import CopyToClipboard from '../Elements/CopyToClipboard';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class CanvasHistory extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   */
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      meta: {},
      page: 1,
      limit: 50,
      columns: {},
      search: '',
      sortBy: 'id',
      direction: 'asc',
      loading: true,
      focus: null,

      optionsLimits: {
        50: true,
        100: false,
        250: false,
      },
      optionsColumns: [
        'id',
        'player_id',
        'details',
        'created_at',
      ],
      optionsColumnsDefault: ['player_id', 'details'],
      optionsColumnLabels: {
        player_id: 'Player ID',
        details: 'Details',
      },

      modals: {},
    };

    this.get = this.get.bind(this);
    this.updateShowModal = this.updateShowModal.bind(this);
    this.updateColumns = this.updateColumns.bind(this);
    this.updateColumnsShowHide = this.updateColumnsShowHide.bind(this);
    this.updateLimits = this.updateLimits.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.updateSortDirection = this.updateSortDirection.bind(this);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.get();

    // Load default settings
    try {
      if (localStorage.defaultColumnsCanvasHistory === undefined
        || JSON.parse(localStorage.defaultColumnsCanvasHistory).length === 0) {
        localStorage.defaultColumnsCanvasHistory = JSON.stringify(this.state.optionsColumnsDefault);
      }
      this.setState({
        optionsColumnsDefault: JSON.parse((localStorage.defaultColumnsCanvasHistory || [])),
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Couldn't load saved preferences.");
    }
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   */
  searchTimeout = null;

  /**
   * Handler before API request
   */
  get(params, callback, failback) {
    this.setState({
      data: [],
      loading: true,
    }, () => {
      // Make initial request
      const defaultPayload = {
        page: this.state.page,
        limit: this.state.limit,
        order_by: `${this.state.sortBy}.${this.state.direction}`,
      };

      if (this.state.search && this.state.search.length > 0) {
        defaultPayload.search = this.state.search;
      }

      Object.keys(this.state.columns).map((item) => {
        if (this.state.columns[item].search && this.state.columns[item].search.length > 0) {
          defaultPayload[item] = this.state.columns[item].search;
        }
        return item;
      });

      this.request(
        (params || defaultPayload),
        // callback
        (response) => {
          if (callback) {
            callback(response);
          } else if (response.histories && response.meta) {
            const columns = {};

            (this.state.optionsColumns).map((item) => {
              columns[item] = {
                label: (this.state.optionsColumnLabels[item])
                  ? this.state.optionsColumnLabels[item]
                  : null,
                search: (this.state.columns[item])
                  ? this.state.columns[item].search
                  : '',
              };

              if (this.state.columns[item] && this.state.columns[item].visible) {
                columns[item].visible = this.state.columns[item].visible;
              } else if (this.state.optionsColumnsDefault
                && this.state.optionsColumnsDefault.indexOf(item) === -1) {
                columns[item].visible = false;
              } else {
                columns[item].visible = true;
              }

              return item;
            });

            this.setState({
              data: response.histories,
              meta: response.meta,
              columns,
              loading: false,
            }, () => {
              // refocus on original input element
              if (this.state.focus) {
                document.getElementById(this.state.focus).focus();
              }
            });
          } else {
            this.setState({
              loading: false,
            });
          }
        },
        // failback
        (error) => {
          if (failback) {
            failback(error);
          }
        },
      );
    });
  }

  /**
   * Main API request
   */
  request(params, callback, failback) {
    let query = '';
    if (params && Object.keys(params).length > 0) {
      Object.keys(params).map((key) => {
        query += `${key}=${params[key]}&`;
        return key;
      });
      query = `?${query}`;
    }

    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/players/${this.props.id}/histories${query}`,
      'GET',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * @param {string} modal
   */
  updateShowModal(modal, show) {
    const { modals } = this.state;
    modals[modal] = show;
    this.setState({
      modals,
    });
  }

  /**
   * @param {object} columns
   * @param {string} key
   */
  updateColumnsShowHide(columns, key, show) {
    // Set defaults for localStorage
    if (localStorage.defaultColumnsCanvasHistory
      && localStorage.defaultColumnsCanvasHistory.length > 0) {
      let def = JSON.parse(localStorage.defaultColumnsCanvasHistory);
      if (show) {
        def.push(key);
      } else {
        def = [...def.slice(0, def.indexOf(key)), ...def.slice((def.indexOf(key) + 1))];
      }
      localStorage.defaultColumnsCanvasHistory = JSON.stringify(def);
    } else {
      localStorage.defaultColumnsCanvasHistory = JSON.stringify([key]);
    }

    // if reseting the search make an updated request
    if (columns[key].search.length > 0 && !show) {
      const newColumns = { ...columns };
      newColumns[key].search = '';
      this.setState({
        columns: newColumns,
        focus: null,
        optionsColumnsDefault: JSON.parse(localStorage.defaultColumnsCanvasHistory),
      }, () => {
        this.get();
      });
    } else { // if no search was present just hide/show the field
      this.setState({
        columns,
        focus: null,
        optionsColumnsDefault: JSON.parse(localStorage.defaultColumnsCanvasHistory),
      });
    }
  }

  /**
   * @param {object} columns
   */
  updateColumns(columns, targetId) {
    this.setState({
      columns,
      focus: (targetId || null),
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.get();
      }, 350);
    });
  }

  /**
   * @param {object} limits
   */
  updateLimits(limits) {
    this.setState({
      page: 1,
      limit: Object.keys(limits).filter((item) => (limits[item]))[0],
      optionsLimits: limits,
    }, () => {
      this.get();
    });
  }

  /**
   * @param {string} search
   */
  updateSearch(search, targetId) {
    this.setState({
      search,
      focus: (targetId || null),
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.get();
      }, 350);
    });
  }

  /**
   * @param {integer} page
   */
  updatePage(page) {
    this.setState({
      page,
    }, () => {
      this.get();
    });
  }

  /**
   * @param {Event} event
   * @param {object} data
   */
  static onClickRow(event) {
    event.preventDefault();
  }

  /**
   * @param {string} data
   */
  static onCopyToClipboard(data) {
    const container = document.getElementById('hidden');
    const root = ReactDOMClient.createRoot(container);

    root.render(
      <CopyToClipboard data={data} callback={() => root.render('')} />,
    );
  }

  /**
   * @param {string} key
   */
  updateSortDirection(key) {
    this.setState((prevState) => {
      let direction = (prevState.direction === 'asc') ? 'desc' : 'asc';
      direction = (prevState.sortBy !== key) ? 'asc' : direction;

      return {
        sortBy: key,
        direction,
      };
    }, () => {
      this.get();
    });
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col col-12">
            <div className="content">
              <div className="section-header">
                <h3>History</h3>
              </div>

              <Tables
                uniqueKey="id"
                search={this.state.search}
                data={this.state.data}
                meta={this.state.meta}
                page={this.state.page}
                limit={this.state.limit}
                columns={this.state.columns}
                sortBy={this.state.sortBy}
                direction={this.state.direction}
                loading={this.state.loading}
                optionsLimits={this.state.optionsLimits}
                optionsSelections={{
                  copy: {
                    label: 'Copy To Clipboard',
                    action: (data) => {
                      const ids = this.state.data.map((item) => ((data.indexOf(item.id) > -1)
                        ? item.id
                        : null)).filter((item) => item);

                      CanvasHistory.onCopyToClipboard(ids);
                    },
                  },
                }}
                optionsRows={{}}
                onUpdateSearch={this.updateSearch}
                onUpdatedColumns={this.updateColumns}
                onUpdateColumnsShowHide={this.updateColumnsShowHide}
                onUpdatedLimits={this.updateLimits}
                onUpdatePage={this.updatePage}
                onUpdateSortDirection={this.updateSortDirection}
                onClickRow={CanvasHistory.onClickRow}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
CanvasHistory.propTypes = {
  id: PropTypes.number,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(CanvasHistory);
